var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCnp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 793.44 572",
    width: 793.44,
    height: 572,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#fff;}.cls-1,.cls-3,.cls-4,.cls-5{fill-rule:evenodd;}.cls-2,.cls-4{fill:#040506;}.cls-3{fill:#132a7a;}.cls-5{fill:#3b9543;}"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_210",
    "data-name": "Grupo 210",
    transform: "translate(-279,-250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_344",
    "data-name": "Trazado 344",
    className: "cls-1",
    d: "M 848.74,386.72 Z M 650.86,480 A 252.38,252.38 0 0 1 848.7,386.72 246.52,246.52 0 0 0 650.86,480 Z m -23,33.52 a 282.88,282.88 0 0 1 23,-33.52 203,203 0 0 0 -23,33.57 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_457",
    "data-name": "Rect\\xE1ngulo 457",
    className: "cls-2",
    x: 855.56,
    y: 577.10999,
    width: 26.200001,
    height: 244.89,
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_345",
    "data-name": "Trazado 345",
    className: "cls-3",
    d: "M 848.74,386.72 Z M 650.86,480 a 203.58,203.58 0 0 0 -23,33.52 282.3,282.3 0 0 1 23,-33.47 z",
    style: {
      fill: "#132a7a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_346",
    "data-name": "Trazado 346",
    className: "cls-4",
    d: "M 850.15,367.47 V 250 H 279 V 821.1 H 850.15 V 425 H 850 c -128.36,0 -172.77,88.58 -172.77,88.58 h -75.6 A 281.48,281.48 0 0 1 850.15,367.47 Z m -487,416.13 -1.82,-5.09 h -9.7 l -1.86,5.09 h -6.11 l 9.52,-24.77 h 8.08 l 9.3,24.77 z m 47.02,-1.6 a 16.14,16.14 0 0 1 -8.63,2 c -5.6,0 -10.67,-2 -12.12,-6.86 l 6.4,-1.24 c 0.87,2.62 3.13,3.51 6.2,3.51 2,0 4.63,-0.6 4.63,-2.66 0,-2.06 -3.37,-2.43 -5.18,-2.79 -5.31,-0.9 -10.5,-2.21 -10.5,-7.61 a 7,7 0 0 1 3.2,-5.84 12.8,12.8 0 0 1 7.47,-2 11,11 0 0 1 11.27,5.82 L 407,765.91 A 4.85,4.85 0 0 0 401.9,763 c -1.86,0 -4.12,0.41 -4.12,2.43 0,2.02 2.6,2.23 4.29,2.42 a 27.12,27.12 0 0 1 7.76,2.09 6.72,6.72 0 0 1 3.9,5.86 7.55,7.55 0 0 1 -3.66,6.09 z m 0.29,-52.19 c -41.21,0 -67.42,-18.45 -67.42,-49.86 0,-31.41 40.49,-46.95 67.42,-46.95 a 108.57,108.57 0 0 1 38.4,4.85 l 1.31,11.15 a 190.7,190.7 0 0 0 -39.71,-4.15 c -8.29,0 -40.85,9.41 -40.85,35.2 0,25.79 20.51,33.94 40.85,37.84 a 92.47,92.47 0 0 0 42.16,-3.76 l -2.06,12.41 a 171.64,171.64 0 0 1 -40.2,3.25 z m 44,52.19 a 16.23,16.23 0 0 1 -8.63,2 c -5.6,0 -10.67,-2 -12,-6.86 l 6.4,-1.24 c 0.87,2.62 3.13,3.51 6.21,3.51 2,0 4.63,-0.6 4.63,-2.66 0,-2.06 -3.37,-2.43 -5.19,-2.79 -5.29,-0.9 -10.5,-2.21 -10.5,-7.61 a 6.92,6.92 0 0 1 3.23,-5.84 12.64,12.64 0 0 1 7.44,-2 11,11 0 0 1 11.27,5.82 l -5.89,1.63 a 4.85,4.85 0 0 0 -5.12,-2.94 c -1.86,0 -4.12,0.41 -4.12,2.43 0,2.02 2.6,2.23 4.29,2.42 a 27.12,27.12 0 0 1 7.76,2.09 6.72,6.72 0 0 1 3.9,5.86 7.53,7.53 0 0 1 -3.78,6.09 z m 49.48,-8.12 a 8.67,8.67 0 0 1 -2.43,7.54 14.37,14.37 0 0 1 -9.14,2.6 16,16 0 0 1 -9.11,-2.14 8.63,8.63 0 0 1 -3.08,-8 v -15 h 7.54 v 15 a 7.31,7.31 0 0 0 0.65,3.83 5.34,5.34 0 0 0 4.46,1.65 6.31,6.31 0 0 0 4.29,-1.34 6.14,6.14 0 0 0 0.83,-4.14 v -15 h 6 z m 40.21,9.7 -4.55,-9.7 h -5.07 v 9.7 h -6.93 v -24.7 h 12.53 a 16,16 0 0 1 7.61,1.26 7.12,7.12 0 0 1 3.78,6.18 6.86,6.86 0 0 1 -5.16,6.4 l 5.5,10.93 z m 47.15,0 -1.84,-5.09 h -9.7 l -1.86,5.09 h -6.11 l 9.52,-24.78 h 8.08 l 9.31,24.78 z m 143.9,-20 h -14.3 v 5.05 h 11.27 v 4.63 h -11.32 v 5.5 h 14.3 v 4.85 h -21.24 v -24.78 h 21.24 z m 40.19,18.33 a 16,16 0 0 1 -8.63,2 11.19,11.19 0 0 1 -12,-6.86 l 6.4,-1.23 c 0.87,2.62 3.12,3.51 6.2,3.51 2,0 4.63,-0.6 4.63,-2.66 0,-2.06 -3.39,-2.43 -5.19,-2.79 -5.3,-0.9 -10.49,-2.21 -10.49,-7.61 a 6.91,6.91 0 0 1 3.2,-5.85 12.86,12.86 0 0 1 7.46,-2 11,11 0 0 1 11.25,5.82 l -5.89,1.62 a 4.85,4.85 0 0 0 -5.09,-2.93 c -1.87,0 -4.12,0.41 -4.12,2.42 0,2.01 2.59,2.24 4.27,2.43 a 27.66,27.66 0 0 1 7.78,2.08 6.75,6.75 0 0 1 3.83,5.84 7.54,7.54 0 0 1 -3.81,6.16 z M 677.29,635.2 h 50.64 c 0,0 53.52,0.51 53.52,36.62 0,34.52 -46.42,33.26 -46.42,33.26 h -32.9 v 22.74 h -24.84 z m 1.79,123.19 a 10.57,10.57 0 0 1 12,8.87 c 0,0.28 0.07,0.55 0.09,0.83 l -7.27,0.41 c 0,-2.76 -1.19,-5.31 -5,-5.31 -4.84,0 -5.38,5.33 -5.38,8.34 0,3.39 0.49,7.76 5.72,7.76 a 5.06,5.06 0 0 0 5.17,-4.66 l 6.76,0.37 a 10.94,10.94 0 0 1 -12.27,9 12.76,12.76 0 0 1 0.22,-25.51 z m -58.86,0.37 h 7.49 l 9.94,14.54 v 0 -14.54 H 643 v 24.77 h -6 l -11.39,-16.65 h -0.17 v 16.65 h -5.4 z M 605.68,691.41 V 635.2 H 616 v 92.62 l -98.42,-56.24 v 56.24 H 505.27 V 635.2 Z",
    style: {
      fill: "#040506",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_347",
    "data-name": "Trazado 347",
    className: "cls-4",
    d: "m 359.6,774 h -6.33 l 3.18,-8.73 z",
    style: {
      fill: "#040506",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_348",
    "data-name": "Trazado 348",
    className: "cls-4",
    d: "m 587.71,774 h -6.42 l 3.17,-8.73 z",
    style: {
      fill: "#040506",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_349",
    "data-name": "Trazado 349",
    className: "cls-4",
    d: "m 544.18,766.22 a 3.17,3.17 0 0 1 -1.73,2.81 9.65,9.65 0 0 1 -4.26,0.54 h -3.81 v -6.33 H 538 a 10.87,10.87 0 0 1 4.46,0.46 3.07,3.07 0 0 1 1.72,2.52 z",
    style: {
      fill: "#040506",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_350",
    "data-name": "Trazado 350",
    className: "cls-4",
    d: "m 755.41,669.91 c 0,22.59 -27.32,22.59 -27.34,22.59 H 702 v -44.43 h 25 c 0,0 28.41,0.75 28.41,21.84 z",
    style: {
      fill: "#040506",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_351",
    "data-name": "Trazado 351",
    className: "cls-4",
    d: "M 850.15,386.84 V 425 H 850 c -128.36,0 -172.77,88.58 -172.77,88.58 h -49.37 a 282.17,282.17 0 0 1 23,-33.53 252.37,252.37 0 0 1 197.84,-93.33 v 0 z",
    style: {
      fill: "#040506",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_352",
    "data-name": "Trazado 352",
    className: "cls-5",
    d: "M 848.7,386.72 A 252.38,252.38 0 0 0 650.86,480 246.53,246.53 0 0 1 848.7,386.72 Z",
    style: {
      fill: "#3b9543",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_353",
    "data-name": "Trazado 353",
    className: "cls-4",
    d: "m 1072.44,513.58 h -47 A 222.86,222.86 0 0 0 850.15,425 v -38.16 h 0.34 a 260.87,260.87 0 0 1 221.95,126.74 z",
    style: {
      fill: "#040506",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnp);
export default __webpack_public_path__ + "static/media/cnp.f0edeebe2a81bee784440651a47dfbe6.svg";
export { ForwardRef as ReactComponent };